import Img from "@/modules/img/components/service/Img";
import { createQueue } from "@/modules/img/components/service/UploadQueue";

/** The app's upload queue (see UploadQueue.js), shown by ImgUploadPanel. */
export default createQueue({
    upload     : (siteId, folderId, file, onProgress) => Img.upload(siteId, folderId, file, onProgress),
    uploadState: (uploadId) => Img.uploadState(uploadId),
});
